import { isConjointOrMaxDiffGroup } from 'utils/nodeTypes';

export default function addNodeMetadata(node, questionnaireEditVersion) {
  if (isConjointOrMaxDiffGroup(node.type)) {
    const newNode = { ...node };
    newNode.startUpdatingAfterVersion = questionnaireEditVersion;
    return newNode;
  }
  return node;
}
